import type { ToolUseRenderBlock } from "@/lib/chat-render";
import { editDiffStats, toolEntryText } from "./tool-entry-label";

/** ツールのラベルを差分の行数表示と合わせて 1 行に省略して描き、省略時だけ全文を出す。実行中は文言が入れ替わるので data-tooltip を使う。 */
export function ToolEntryLabel({
	tool,
	className = "min-w-0 truncate",
	testId,
}: {
	tool: ToolUseRenderBlock;
	className?: string;
	testId?: string;
}) {
	const text = toolEntryText(tool);
	return (
		<span data-testid={testId} data-tooltip={text} data-tooltip-if-truncated className={className}>
			{text}
			{editDiffStats(tool)}
		</span>
	);
}
